import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsSymmetry = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M22.77 3 10.159 8.224 4.425 22.065l5.734 13.842L22.77 41.13zm15.071 9.094L25.23 6.87V45l12.611-5.223 5.733-13.842z" }) }) })
});
export default SvgMetricsSymmetry;
